export default __webpack_public_path__ + "static/wrench.888283f2eb34f578fdb08195742e3a61.svg";